// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.modal-body {
  width: 500px;
  font-size: 14px;
}

.form-group {
  margin-bottom: 1rem;
}

.input-label {
  display: block;
}



.fullrow {
  width: 100%;
}

:host ::ng-deep .p-inputnumber,
p-inputnumber{
  width: 100%;
}
:host ::ng-deep .p-calendar{
  width: 100%;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
